module.exports = __webpack_public_path__ + "img/ico_thirdparty_instagramfeed.182fc6e5.png";